import store from '@/store'
import { runMutation } from '../graphQl'
import { lifeCycleStatusUpdateMutation, StartLifecycleWorkflowMutation } from '../query/lifeCycle'

export const lifeCycleStatusUpdate = ({ documentId = null, status = null, undoCheckout = false, bomId = null, materialId = null }) => {
  const tokenType = store.getters?.isOnProjectLevel ? 'project' : 'tenant'
  return runMutation(lifeCycleStatusUpdateMutation(), { document_id: documentId, status, undo_checkout: undoCheckout, bom_id: bomId, material_id: materialId }, tokenType)
}

export const StartLifecycleWorkflow = ({ bomId = null, materialId = null, documentId = null, stepId, templateId, assignees = [] }) => {
  const body = {
    bomId: bomId ?? undefined,
    materialId: materialId ?? undefined,
    documentId: documentId ?? undefined,
    assignees: assignees.length > 0 ? assignees : undefined,
    stepId,
    templateId
  }
  const tokenType = store.getters?.isOnProjectLevel ? 'project' : 'tenant'
  return runMutation(StartLifecycleWorkflowMutation(), body, tokenType)
}
